import { Button, Grid, Typography } from "@mui/material";
import React, { useEffect } from "react";

function FileUpload({ id, doc, setDoc, type, isEditable }) {
  const uploadFiles = (event) => {
    setDoc((e) => ({
      ...e,
      [type]: [...e[type], event.target.files[0]],
    }));
  };

  return (
    <Grid
      container
      sx={{
        width: "100%",
        height: 50,
      }}
    >
      <input
        style={{ display: "none" }}
        type="file"
        id={`contained-button-file-${id}`}
        onChange={uploadFiles}
      />

      <label htmlFor={`contained-button-file-${id}`}>
        <Button
          variant="contained"
          component="span"
          sx={{ backgroundColor: "#6a86a7", height: 30 }}
        >
          <Typography
            sx={{
              textTransform: "lowercase",
            }}
          >
            Choose file
          </Typography>
        </Button>
      </label>
    </Grid>
  );
}

export default FileUpload;
